import Chip from "components/common/Chip";
import Image from "components/common/images/Image";
import { CandidateCorpModel } from "models";
import React, { ChangeEvent, MouseEvent } from "react";
import { MdOutlineCancel } from "react-icons/md";
import { Link } from "react-router-dom";

type PROPS = {
  item: CandidateCorpModel;
  selectedList: CandidateCorpModel[];
  onChangeSelectedState: (item: CandidateCorpModel, value: boolean) => void;
  onDelete: (item: CandidateCorpModel) => void;
};

const CandidateCorpListItem: React.FC<PROPS> = (props) => {
  const item = props.item;

  const selected = props.selectedList.includes(props.item);

  const onChangeCheckbox = (e: ChangeEvent<HTMLInputElement>) => {
    props.onChangeSelectedState(props.item, e.target.checked);
  };
  const onDelete = (e: MouseEvent<HTMLButtonElement>) => {
    props.onDelete(props.item);
  };

  return (
    <div>
      <div className="flex justify-between border-b border-b-black">
        <label>
          <input
            className="cursor-pointer"
            style={{zoom: "1.5"}}
            type="checkbox"
            checked={selected}
            onChange={onChangeCheckbox}
          />
          <span className="ml-4 font-bold text-2xl">{item.corp_name}</span>
        </label>
        <button onClick={onDelete}>
          <MdOutlineCancel className="text-2xl" />
        </button>
      </div>
      <div className="flex gap-4 p-4 border-b border-b-black">
        <div className={`w-40 ${item?.logo_image?.image_url ? 'h-40' : 'hidden'}`}>
          <Image maxHeight="165px" data={item.logo_image} />
        </div>
        <div className="flex-1">
          <div className="whitespace-pre-line line-clamp-5 break-all" title={item.introduction}>
            {item.introduction}
          </div>
          <div className="m-2 flex flex-wrap gap-x-4 gap-y-2">
            {item.corp_tag_list.map((tag, index) => (
              <Link
                key={index}
                to={{
                  pathname: "/company-list/",
                  search: `keyword=${tag.corp_tag}&get_count=10`,
                }}
              >
                <Chip text={tag.corp_tag} />
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CandidateCorpListItem;
